import { init } from '../../Notifications/Push/notificationOrchestrator';
import { getUserAction } from '../../Reducks/User/actions';

const isNewUserLoaded = (action, state) => (
  action.type === String(getUserAction.fulfilled) && action.payload.metadata && !state.user.metadata
);

const notificationsMiddleware = ({ getState, dispatch }) => (next) => (action) => {
  const stateBefore = getState();
  const result = next(action);
  if (isNewUserLoaded(action, stateBefore)) {
    init(getState().user, dispatch);
  }
  return result;
};

export default notificationsMiddleware;
